import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { useEffect, useState } from 'react'
import { IEquipment, IEquipmentPassport } from '@/pages/Equipment/equipment.types.ts'
import equipmentApi from '@/pages/Equipment/equipment.api.ts'

const useEquipmentPassport = (passportId: IEquipment['passportInstanceId']) => {
  const { wait, loading } = useHttpLoader()
  const [passport, setPassport] = useState<IEquipmentPassport>(null)

  useEffect(() => {
    wait(equipmentApi.getEquipmentPassport(passportId), (resp) => {
      if (resp.status === 'success') {
        setPassport(resp.body)
      }
    })
  }, [passportId])

  return { loading, passport, setPassport }
}

export default useEquipmentPassport
